module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon_rotate_48x48_hover_VA.d6f323cb.svg";